import React from "react";
import logger from "logger";
import { getStyleJSON } from "Utils/Common";
import { DialogButton } from "Common/DialogButton";
import TaskInput from "TaskDialogCommon/TaskInput";

export default function(props) {
  const { label, instructions, taskConfig, param, setValue, itemAlias = "" } = props;
  logger.log(props);
  const [
    userInputExcludeChestName,
    setuserInputExcludeChestName,
  ] = React.useState(null);

  return (
    <div style={{ padding: "7px" }}>
      <div
        style={getStyleJSON(
          "padding-left: 0px; padding-right: 0px; padding-top:5px;"
        )}
      >
        {label}
      </div>

      {instructions && (
        <div
          style={getStyleJSON("font-size: 10px; color: blue;padding-top:5px;")}
        >
          {instructions}
        </div>
      )}

      <div
        style={getStyleJSON(
          "padding-left: 0px; padding-right: 0px; padding-top:5px;"
        )}
      >
        <TaskInput
          value={userInputExcludeChestName}
          onChange={(event) => setuserInputExcludeChestName(event.target.value)}
        />
      </div>

      <div
        style={getStyleJSON(
          "padding-left: 0px; padding-right: 0px; padding-top:5px;display: inline-flex;"
        )}
        className="fullWidth"
      >
        <DialogButton
          label={`Add ${itemAlias}`}
          style={getStyleJSON(
            "width: 150px; font-weight: bold; font-size: 15px"
          )}
          onClick={() => {
            if (
              userInputExcludeChestName === null ||
              userInputExcludeChestName.trim().length === 0
            ) {
              alert("Please enter a name to add.");
              return;
            }
            setValue(
              {
                target: {
                  value: [...taskConfig[param], userInputExcludeChestName],
                },
              },
              param
            );
            setuserInputExcludeChestName("");
          }}
        />
        <DialogButton
          style={getStyleJSON(
            "font-weight: bold; width: 150px; font-size: 15px"
          )}
          label="Clear"
          onClick={() => {
            setValue(
              {
                target: {
                  value: [],
                },
              },
              param
            );
            setuserInputExcludeChestName("");
          }}
        />
      </div>

      {taskConfig[param] &&
        taskConfig[param].map((value) => {
          return (
            <div style={getStyleJSON("border: solid 1px; padding-top:5px;")}>
              <div
                style={getStyleJSON(
                  "padding-left: 20px; padding-right: 0px; width: 170px;"
                )}
              >
                {value}
              </div>
            </div>
          );
        })}
    </div>
  );
}
